export default class pianoManutenzione{
    CodiceAttivita;
    DescrAttivita;
    TipoFrequenzaTemporale;
    FrequenzaTemporale;
    DataUltima;
    DataProssima;
    Manutentore;
    SysChiaveglobale;

    constructor(){}
}